module.exports = __webpack_public_path__ + "static/media/call_24px.24db0b55.svg";